import Loading from "@@/core/components/shared/Loading/Loading";
import mixins from "@@/core/mixins/mixins";
import CustomerSearch from "@@/core/components/shared/CustomerSearch/CustomerSearch";

import {
  BButton,
  BCard,
  BTable,
  BCollapse,
  BFormGroup,
  BFormInput,
  BModal,
  VBModal,
  BFormTextarea,
  BFormSelect,
  VBToggle,
  BForm,
} from "bootstrap-vue";
export default {
  name: "Products",
  mixins: [mixins],
  components: {
    Loading,
    BButton,
    BCard,
    BTable,
    BCollapse,
    BFormGroup,
    BFormInput,
    BModal,
    VBModal,
    BFormTextarea,
    CustomerSearch,
    BForm,
    BFormSelect,
  },
  directives: {
    "b-modal": VBModal,
    "b-toggle": VBToggle,
  },
  data() {
    return {
      url: "admin/products",
      items: [],
      createForm: {
        serial: null,
        description: "",
        receive_datetime: "",
        user: null,
        address: null,
      },
      adressess: [],
      selectedAdressess: null,
      fields: [
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "username",
          label: "نام کاربر",
        },
        {
          key: "receive_datetime",
          label: "تاریخ دریافت",
        },
        {
          key: "status",
          label: "وضعیت",
        },
        {
          key: "result",
          label: "نتیجه",
        },
        {
          key: "edit",
          label: "ویرایش",
        },
        {
          key: "delete",
          label: "حذف",
        },
      ],
      filter: {
        serial: "",
        status: null,
        start_date: "",
        end_date: "",
        user_id: "",
      },
      statusOptions: [
        {
          value: null,
          text: "همه",
        },
        {
          value: "canceled",
          text: "لغو شده",
        },
        {
          value: "new",
          text: "جدید",
        },
        {
          value: "done",
          text: "انجام شده",
        },
        {
          value: "received",
          text: "دریافت شده",
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    "createForm.user": function(newVal) {
      if (newVal && newVal.id) {
        this.findAddresses(newVal.id);
      }
    },
  },
  methods: {
    async loadData() {
      await this.$axios
        .get("admin/experiments", {
          params: {
            serial: this.filter.serial,
            status: this.filter.status,
            start_date: this.filter.start_date,
            end_date: this.filter.end_date,
            user_id: this.filter.user_id ? this.filter.user_id.id : null,
          },
        })
        .then((res) => {
          this.$root.notify(res.data.message, "success");
          this.items = res.data.data.experiments;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteItem(id) {
      window
        .swal({
          title: "آیتم حذف شود؟",
          text: "این عملیات غیر قابل بازگشت خواهد بود",
          icon: "warning",

          showCancelButton: true,
          showConfirmButton: true,
          dangerMode: true,
          buttons: ["خیر", "بله حذف کن"],
        })
        .then((willDelete) => {
          if (willDelete) {
            this.$axios
              .delete(`admin/experiments/${id}`)
              .then((response) => {
                this.items.data = this.items.data.filter(
                  (item) => item.id != id
                );
                window.swal({
                  icon: "success",
                  showConfirmButton: true,
                  text: response.data.message,
                  button: "باشه",
                });
              })
              .catch((error) => {
                window.swal({
                  title: "خطا",
                  showConfirmButton: true,
                  text: error.response.data.message,
                  button: "باشه",
                });
              });
          }
        })
        .catch(() => {});
    },
    async findAddresses(userId) {
      await this.$axios.get(`admin/users/${userId}/addresses`).then((res) => {
        this.adressess = res.data.data.addresses.map((address) => {
          address.label = address.id + " - " + address.address;
          return address;
        });
      });
    },
    async submitHandler() {
      let formData = new FormData();
      formData.append("serial", this.createForm.serial);
      formData.append("description", this.createForm.description);
      formData.append("receive_datetime", this.createForm.receive_datetime);
      formData.append("user_id", this.createForm.user?.id);
      formData.append("address_id", this.createForm.address?.id);
      this.disabled = true;
      await this.$axios
        .post("admin/experiments", formData)
        .then((res) => {
          this.items.data.push(res.data.data.experiment);
          this.$root.$emit("bv::hide::modal", "modal-add-experiment");
          this.$root.notify(res.data.message, "success");
        })
        .catch((error) => {
          this.$root.notify(error);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
    doFilter() {
      this.loadData();
    },
  },
};
